export default {
      id: "file-search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#file-search",
      toString: function () {
        return this.url;
      }
    }